import type { AuthState } from '@gea/digital-ui-lib';

export const LOGOUT_REQUESTED = 'logout requested' as AuthState;
